// Web replacement for react-native-fs (native-only package).
// Wired up via the "browser" field in package.json; on native, metro.config.js
// resolves the real package instead. Only reached behind Platform.OS !== 'web'
// checks, so these stubs are never actually invoked on web.
export default {
  DocumentDirectoryPath: '',
  writeFile: () => Promise.reject(new Error('react-native-fs is not available on web')),
};
